import {Intent, MoneyColor} from "./types";

export function intentMainColor(mainPocketId: string, intent: Intent): MoneyColor | undefined {
  if (intent.toPocketId === mainPocketId) {
    return MoneyColor.Income
  }
  if (intent.fromPocketId === mainPocketId) {
    return MoneyColor.Expense
  }
  return undefined
}
